<script>
import {
    v4 as uuidv4
} from 'uuid';

import {
    Node,
    Slice
} from "prosemirror-model";
import {
    Selection,
    NodeSelection,
    TextSelection,
} from "prosemirror-state";

export default {
    name: 'FileAttachmentHelper',

    data() {
        return {
            objectUrls: [],
        }
    },

    beforeDestroy() {
        this.cleanup();
    },

    methods: {

        selected(files) {

            for (var i = 0; i < files.length; i++) {
                var file = files[i];

                //this is just for before we upload 
                //so we know this files id incase the name 
                //is changed before upload
                var temp_file_id = uuidv4();

                var fileObject = {
                    file: file,
                    uuid: temp_file_id
                };

                if (!file.name) {
                    continue;
                }

                //the backend will set the href later
                var src = URL.createObjectURL(file);

                var data = {
                    href: src,
                    linkText: file.name,
                    uuid: temp_file_id
                }
                this.editor.commands.createUploadFile(data);
                this.$emit("selected", fileObject);
            }

        },
        renameUploadClick(ref) {
            
            var filename = this.editor.state.selection.node.attrs.linkText;
            this.$refs[ref].filename = filename;
            this.$refs[ref].open();
        },
        renameConfirmed(filename) {

            var file_id = this.editor.state.selection.node.attrs.uuid;

            var data = {
                linkText: filename,
                uuid: file_id
            };
            this.$emit("renamed", data);
            this.editor.commands.renameUploadFile(data);

        },

        captionClick(ref) {
            var caption = this.editor.state.selection.node.attrs.caption;
            this.$refs[ref].caption = caption;
            this.$refs[ref].open();
        },

        captionImage(caption) {
            var data = {
                caption: caption,
            };
            this.editor.commands.captionOverflowImage(data);
        },

        blobToBase64(blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                var base64data = reader.result;
                callback(base64data);
            }
        },
        resizeBase64Img(base64, limit) {
            return new Promise((resolve, reject) => {
                var canvas = document.createElement("canvas");
                let context = canvas.getContext("2d");
                let img = document.createElement("img");
                img.src = base64;
                img.onload = function () {
                    var width = img.width;
                    var height = img.height;

                    var maxSize = height > width ? height : width;

                    if (maxSize > limit) {
                        height = height / maxSize * limit;
                        width = width / maxSize * limit;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    context.drawImage(img, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', .3));
                }
            });
        },
        imageSelected(imageObj) {

            var blob = imageObj.blob;

            const imageUrl = URL.createObjectURL(blob);

            this.objectUrls.push(imageUrl);

            var ratio = imageObj.height / imageObj.width * 100;

            var file = new File([blob], imageObj.filename, {
                lastModified: new Date()
            });

			if(this.editorHasFile(file.name)){
				file = this.addRandomCharactersToFileName(file)
			}

            this.$emit("selected", {
                file: file
            });

            var data = {
                src: imageUrl,
                title: file.name,
                ratio: ratio.toString(),
				originalWidth: imageObj.width.toString()
            };
            this.editor.commands.createOverflowImage(data);

            // this.blobToBase64(blob, function (base64) {
            //     temp.resizeBase64Img(base64, 128).then(function (dataUrl) {
            //         
            //         var data = {
            //             src: imageUrl,
            //             title: imageObj.filename,
            //             ratio: ratio.toString(),
            //             placeholder: dataUrl
            //         };
            //         temp.editor.commands.createOverflowImage(data);
            //     })
            // })
        },

        imageFileSelected(imageFile) {
            const imageUrl = URL.createObjectURL(imageFile);


			//if we already have this file name add 5 random characters
			//to the end of the file name
			if(this.editorHasFile(imageFile.name)){
				imageFile = this.addRandomCharactersToFileName(imageFile)
			}

            this.objectUrls.push(imageUrl);

            this.$emit("selected", {
                file: imageFile
            });

            var image = new Image();
            image.src = imageUrl;
            var temp = this;
            image.onload = function (evt) {
                var width = this.width;
                var height = this.height;

                var ratio = height / width * 100;

                var data = {
                    src: imageUrl,
                    title: imageFile.name,
                    ratio: ratio.toString(),
					originalWidth: width.toString()
                };
                temp.editor.commands.createOverflowImage(data);
            };
        },

        videoSelected(file) {
			if(this.editorHasFile(file.name)){
				file = this.addRandomCharactersToFileName(file)
			}

            const videoUrl = URL.createObjectURL(file);
            this.objectUrls.push(videoUrl);
            var data = {
                src: videoUrl,
                title: file.name
            };
            this.editor.commands.createVideo(data);

            this.$emit("selected", {
                file: file
            });
        },
        posterSelected(imageObj) {
            var blob = imageObj.blob

            const imageUrl = URL.createObjectURL(blob);

            this.objectUrls.push(imageUrl);

            

            var file = new File([blob], imageObj.filename, {
                lastModified: new Date()
            });

			if(this.editorHasFile(file.name)){
				file = this.addRandomCharactersToFileName(file)
			}

			var data = {
                src: imageUrl,
                title: file.name
            };
            this.editor.commands.videoPoster(data);

            this.$emit("selected", {
                file: file
            });
        },

        scanForUploads() {
            var uploads = [];
            this.editor.state.doc.descendants(function (node) {
                if (node.type.name == "uploadfile") {
                    //if a uploadfile has an href it has already been uploaded
                    //we don't need to keep track of those ones 
                    if (node.attrs.href.startsWith("blob")) {
                        uploads.push(node.attrs.linkText);
                    }
                } else if (node.type.name == "overflowImage") {
                    //if a overflowImage has a blob it means we haven't uploaded the attachment yet
                    //keep track of it
                    if (node.attrs.src.startsWith("blob")) {
                        uploads.push(node.attrs.title);
                    }
                } else if (node.type.name == "customvideo") {
                    
                    //if a customvideo has a blob it means we haven't uploaded the attachment yet
                    //keep track of it
                    if (node.attrs.src.startsWith("blob")) {
                        uploads.push(node.attrs.title);
                    }
                    if (node.attrs.poster.startsWith("blob")) {
                        uploads.push(node.attrs.posterTitle);
                    }
                }
            })

            return uploads
        },

		editorHasFile(file_name){

			var uploads = [];
            this.editor.state.doc.descendants(function (node) {
                if (node.type.name == "uploadfile") {
                    //if a uploadfile has an href it has already been uploaded
                    //we don't need to keep track of those ones 
                    if (node.attrs.linkText==file_name) {
                        uploads.push(node.attrs.linkText);
                    }
                } else if (node.type.name == "overflowImage") {
                    //if a overflowImage has a blob it means we haven't uploaded the attachment yet
                    //keep track of it
                    if (node.attrs.title==file_name) {
                        uploads.push(node.attrs.title);
                    }
                } else if (node.type.name == "customvideo") {
                    
                    //if a customvideo has a blob it means we haven't uploaded the attachment yet
                    //keep track of it
                    if (node.attrs.title==file_name) {
                        uploads.push(node.attrs.title);
                    }
                    if (node.attrs.posterTitle==file_name) {
                        uploads.push(node.attrs.posterTitle);
                    }
                }
            })

            return uploads.length>0		

		},

        cleanup() {

            for (var i = 0; i < this.objectUrls.length; i++) {
                URL.revokeObjectURL(this.objectUrls[i]);
            }

        },

		addRandomCharactersToFileName(file){
			var extension = file.name.split('.').pop();

			var filename = file.name.split('.').slice(0, -1).join('.');

			return new File([file], filename + "-" + uuidv4().substr(0,5) + "." + extension, {type: file.type});
		},

		syncAttachments(new_json_doc){

			var attachments = this.scanNodeAttachments(new_json_doc);

			var editor_doc = this.editor.getJSON();

			this.syncNodeWithAttachments(editor_doc,attachments);

			this.replaceDoc(editor_doc);

			this.saveTimer = 0;
            this.hasSavedMostRecent = true;

		},

		replaceDoc(doc){

			var selection = this.editor.state.selection;

            var transaction = this.editor.state.tr;
            var new_doc = Node.fromJSON(this.editor.schema, doc);
            transaction.replace(0, this.editor.state.doc.content.size, new Slice(new_doc.content, 0, 0));

            var from = transaction.doc.resolve(selection.from);
            var to = transaction.doc.resolve(selection.to);

            var new_selection

            if (selection instanceof TextSelection) {
                new_selection = new TextSelection(from, to);
            } else if (selection instanceof NodeSelection) {
                new_selection = new NodeSelection(from);
            } else if (selection instanceof AllSelection) {
                new_selection = new AllSelection(transaction.doc);
            }

            transaction.setSelection(new_selection);

            this.editor.view.dispatch(transaction);

		},

		syncNodeWithAttachments(node,attachments){
			if(this.nodeHasAttachment(node)){
				var attachment = attachments.shift();
				node.attrs = attachment.attrs;
			}else if(node.content){
				for(var i=0;i<node.content.length;i++){
					this.syncNodeWithAttachments(node.content[i],attachments);
				}
			}
		},

		scanNodeAttachments(node){

			var result = []

			if(this.nodeHasAttachment(node)){
				result.push(node);
			}else if(node.content){
				for(var i=0;i<node.content.length;i++){
					result = result.concat(this.scanNodeAttachments(node.content[i]));
				}
			}

			return result;

		},

		nodeHasAttachment(node){
			var attachmentTypes = [
				"customvideo",
				"overflowImage",
				"fitImage",
				"uploadfile",
			];
			return attachmentTypes.includes(node.type);
		}

    },
}
</script>
